var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticStyle:{"height":"100%"}},[_c('v-card-title',{staticClass:"d-flex justify-space-between"},[_c('div',[_vm._v("Recently Matched Files")])]),(_vm.initialRequest)?_c('project-files-table-small',{attrs:{"initial-request":_vm.initialRequest,"small":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }